import PropTypes from 'prop-types';
import React from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

const DropdownTextComp = ({
  selectedValue,
  name,
  label,
  options,
  error,
  errorMessage,
  handleChange,
  disabled,
  marginTop,
  marginBottom,
  marginRight,
  required = false,
  multiSelect = false,
  noBorder,
}) => {
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 250,
      },
    },
  };

  return (
    <FormControl
      fullWidth
      sx={{
        marginTop: marginTop || 2,
        marginBottom: marginBottom || 2,
        opacity: disabled && 0.8,
        marginRight,
      }}
      required={required}
      error={error}>
      <InputLabel id="dropdown-label">{label}</InputLabel>
      <Select
        labelId="dropdown-label"
        name={name}
        value={selectedValue}
        onChange={handleChange}
        label={label}
        IconComponent={ExpandMoreRoundedIcon}
        disabled={disabled}
        multiple={multiSelect}
        MenuProps={MenuProps}
        renderValue={selected =>
          multiSelect ? (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
              {selected?.map(value => (
                <Chip
                  key={value}
                  label={
                    options?.find(option => option?.value === value)?.label ||
                    value
                  }
                />
              ))}
            </Box>
          ) : (
            options?.find(option => option?.value === selected)?.label ||
            selected
          )
        }
        sx={{
          '& .MuiSelect-icon': {
            color: 'grey',
          },
          borderRadius: '8px',
          ...(noBorder && {
            width: '70px',
            border: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiSelect-select': {
              padding: '0 8px',
            },
          }),
        }}>
        {options?.map((option, index) => {
          const value = typeof option === 'object' ? option.value : option;

          return (
            <MenuItem
              key={index}
              value={value}
              disabled={option?.disabled}
              sx={{height: '48px'}}>
              {typeof option === 'object' ? option?.label : option}
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

DropdownTextComp.propTypes = {
  disabled: PropTypes.any,
  error: PropTypes.any,
  errorMessage: PropTypes.any,
  fieldDisable: PropTypes.any,
  handleChange: PropTypes.any,
  isLoanDateDisabled: PropTypes.any,
  label: PropTypes.any,
  name: PropTypes.any,
  marginBottom: PropTypes.any,
  marginTop: PropTypes.any,
  options: PropTypes.any,
  selectedValue: PropTypes.any,
  required: PropTypes.any,
  multiSelect: PropTypes.bool,
  noBorder: PropTypes.bool,
  marginRight: PropTypes.any,
};

export default DropdownTextComp;
